export const base64ToArrayBuffer = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

export const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  const binary = bytes.reduce(
    (acc, byte) => acc + String.fromCharCode(byte),
    ""
  );
  return btoa(binary);
};

export const getSecretKey = async (rawKey) => {
  let keyBuffer = base64ToArrayBuffer(rawKey);
  if (keyBuffer.byteLength !== 16 && keyBuffer.byteLength !== 32) {
    throw new Error("Chiave AES non valida: deve essere di 128-bit o 256-bit.");
  }
  return await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"]
  );
};

export const encryptMoreTxi = async (moreTxi) => {
  const moreTxiJson = JSON.stringify({ moreTXI: moreTxi });
  const moreTxiBase64Encoded = btoa(moreTxiJson);
  return moreTxiBase64Encoded;
};
